import { Box, styled } from '@mui/material';

export const StyledGeneralTabBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
  paddingTop: theme.spacing(6)
}));
